import React from "react";
import Image from "./sidebarModules/Image";
import Text from "./sidebarModules/Text";

export default function SidebarModuleFactory({ module }) {
  let moduleComponent = null;
  switch (module.section_name) {
    case "image":
      // image
      moduleComponent = <Image image={module.image} />;
      break;

    case "text":
      // text
      moduleComponent = (
        <Text
          disableMargins={false}
          text={module.text}
          bgColor={module.background_color}
          textColor={module.text_color}
        />
      );
      break;
    default:
      break;
  }
  return moduleComponent;
}
